/**
 * @lodex-pro/web-portal/routes/DisposalHome — disposal-portal landing stub.
 *
 * Phase 16 / DEC-159 — disposal-tree authenticated placeholder. The full
 * disposal portal (ticket views, capacity view, MQTT publish, etc.) ships in
 * Phase 16.4+ per the 10-module toggle catalog (DEC-005 + DEC-158). This stub
 * exists SOLELY so a disposal-pool user who lands after `signIn()` succeeds
 * has SOMETHING to see — the previous behavior was a route 404 because there
 * was no disposal subtree at all.
 *
 * Intentionally minimal:
 *   - Matches PortalHome's dark-theme palette (background #0b0f19, text #e5e7eb)
 *     so the visual language is consistent between operator + disposal portals.
 *   - Does NOT call any disposal-portal API (there isn't one yet; the /v1/
 *     endpoints for disposal are activation + module-toggle admin routes, not
 *     a `/me` read).
 *   - Renders a "Sign out" affordance via PortalShell — this stub does NOT own
 *     its own header; it renders INSIDE the same shell as the operator tree
 *     for now. When the real disposal modules land, `App.tsx` may split the
 *     shell.
 *
 * Spec: DEC-159; DEC-005 (10 disposal modules); DEC-158 (activation lifecycle).
 */

import React from 'react';

export function DisposalHome(): React.JSX.Element {
  return (
    <main
      style={{
        padding: '32px',
        maxWidth: '720px',
        margin: '0 auto',
        color: 'var(--color-text-primary)',
      }}
    >
      <h1 style={{ marginBottom: '8px' }}>lodeX Pro Disposal Portal</h1>
      <p style={{ color: 'var(--color-text-tertiary)', marginBottom: '16px' }}>
        Welcome — your disposal account is active.
      </p>
      <section
        aria-label="Disposal portal status"
        style={{
          padding: '16px',
          border: '1px solid var(--color-border-secondary)',
          borderRadius: '10px',
          background: 'var(--color-bg-tertiary)',
        }}
      >
        <h2 style={{ fontSize: '16px', marginBottom: '8px' }}>Coming soon</h2>
        <p style={{ fontSize: '14px', color: 'var(--color-text-tertiary)', marginBottom: '8px' }}>
          Ticket views, capacity dashboards, custom reports, and MQTT publishing will appear here as
          your enabled modules come online.
        </p>
        <p style={{ fontSize: '13px', color: 'var(--color-text-tertiary)' }}>
          Your account administrator at Paelode Systems will enable modules individually as they are
          onboarded.
        </p>
      </section>
    </main>
  );
}
